import { LiveCountId, LiveCountIdSchema } from "../id"
import { DocumentSnapshotLike } from "../firestore"
import { z } from "zod/v4"
import { CreatedAt, UpdatedAt } from "./system"

export const LiveCountDocumentMeta = z.object({
  current: z.number(),
  overall: z.number(),
})

export type LiveCountDocumentMeta = z.infer<typeof LiveCountDocumentMeta>

export const LiveCountDocumentBody = z.intersection(
  LiveCountDocumentMeta,
  z.object({
    created_at: CreatedAt,
    updated_at: UpdatedAt,
  })
)

export type LiveCountDocumentBody = z.infer<typeof LiveCountDocumentBody>

export const LiveCountDocument = z.intersection(
  LiveCountDocumentBody,
  z.object({ id: LiveCountIdSchema }),
)

export type LiveCountDocument = z.infer<typeof LiveCountDocument>

export class LiveCountDocuments {

  public static readonly MAX_COUNT = 1

  static toDocumentData(spaceUser: LiveCountDocument): object {
    return {
      ...spaceUser,
      // id は document path に入るので入れない
      id: undefined,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): LiveCountDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: LiveCountId(doc.id),
      current: data["current"],
      overall: data["overall"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}
